import { isFeatureEnabled } from 'owa-feature-flags';
import { isImageFile } from 'owa-file';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

export function isThumbnailViewSupported(
    fileName: string,
    providerType: AttachmentDataProviderType
): boolean {
    return (
        isFeatureEnabled('doc-deprecateCloudy-preview-thumbnailView') &&
        providerType === AttachmentDataProviderType.OneDriveConsumer &&
        isImageFile(fileName)
    );
}
